export default function HomePage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-amber-50 to-teal-50 flex items-center justify-center p-6">
      <div className="max-w-2xl w-full bg-white rounded-3xl shadow-2xl p-12 text-center">
        <div className="mb-8">
          <img 
            src="https://static.readdy.ai/image/6137bb11d8f0ec52f72790e4770a5294/dd678fa2586951ecfb6b19bd8f2d8143.jpeg" 
            alt="Jin Guk Korean Cuisine Logo" 
            className="h-24 w-24 object-cover rounded-full mx-auto mb-6 shadow-lg"
          />
          <h1 className="text-5xl font-bold text-gray-900 mb-3">진국밥</h1>
          <p className="text-2xl text-gray-600 font-light">Jin Guk Korean Cuisine</p>
        </div>

        <div className="mb-10 py-8 border-y border-gray-200">
          <p className="text-3xl font-semibold text-gray-900 mb-4 leading-relaxed">
            당분간 전화 주문만 받습니다
          </p>
          <p className="text-lg text-gray-600">
            We are currently accepting phone orders only
          </p>
        </div>

        <div className="space-y-6">
          <div className="bg-teal-50 rounded-2xl p-6">
            <div className="flex items-center justify-center gap-3 mb-3">
              <i className="ri-phone-fill text-teal-600 text-3xl"></i>
              <h2 className="text-2xl font-bold text-gray-900">전화 주문</h2>
            </div>
            <a 
              href="tel:7065908607"
              className="inline-flex items-center gap-2 text-3xl font-bold text-teal-600 hover:text-teal-700 transition-colors cursor-pointer"
            >
              (706) 590-8607
            </a>
          </div>

          <div className="bg-gray-50 rounded-2xl p-6">
            <div className="flex items-center justify-center gap-3 mb-3">
              <i className="ri-map-pin-line text-gray-600 text-2xl"></i>
              <h3 className="text-xl font-semibold text-gray-900">위치</h3>
            </div>
            <p className="text-gray-700">1009 Towne Center Blvd Suite 107</p>
            <p className="text-gray-700">Pooler, GA 31322</p>
            <p className="text-sm text-gray-500 mt-2">Maui Plaza</p>
          </div>

          <div className="bg-amber-50 rounded-2xl p-6">
            <div className="flex items-center justify-center gap-3 mb-3">
              <i className="ri-time-line text-amber-600 text-2xl"></i>
              <h3 className="text-xl font-semibold text-gray-900">영업시간</h3>
            </div>
            <div className="text-gray-700 space-y-1">
              <p>일요일: 11:00 AM - 8:00 PM</p>
              <p className="text-red-600 font-medium">월요일: 휴무일</p>
              <p>화-금: 11:00 AM - 2:30 PM, 4:30 PM - 9:00 PM</p>
              <p>토요일: 11:00 AM - 9:00 PM</p>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-gray-200">
          <p className="text-gray-500 text-sm">
            이용에 불편을 드려 죄송합니다<br />
            Thank you for your understanding
          </p>
        </div>
      </div>
    </div>
  );
}
